module.exports = __webpack_public_path__ + "img/SLDS-icons.1574c235.svg";